import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigServerService, CustomHttp } from '../../../../core';
import { RepresentanteFilter } from '../filter';
import { RepresentanteSearch } from '../representante-search';

@Injectable({
    providedIn: 'root'
})
export class RepresentanteSearchHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/representante`;
    }

    /** Pesquisa os representantes */
    search(filter: RepresentanteFilter, orderBy: number, orderByDir: string, limit: number, offset: number): Observable<RepresentanteSearch> {
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        // Order By
        params = params.append('orderBy', orderBy ? orderBy.toString() : null)
                    .append('orderByDir', orderByDir ? orderByDir : null);
        // Limit
        params = params.append('limit', limit ? limit.toString() : null);
        // Offset
        params = params.append('offset', offset ? offset.toString() : null);

        return this.customHttp.get<RepresentanteSearch>(this.pathApi, {params});
    }
}
